import request from "@/utils/request";
import { methods } from "underscore";

// const AliUrl = "AliUrl/" // 阿里服务接口URL
// const AliUrl = "aui/api/v1/class/" // 阿里服务接口URL
const AliUrl = `${process.env.VUE_APP_AUI_LIVE_BASE_API}` // 阿里服务接口URL

// 首页人气主播
export function getUperRankList(data) {
    return request({
        url: "/api/front/user/infos?type=uper_rank",
        method: "get",
        params: data,
    });
}

export function getAnchorList(data) {
    return request({
        url: "/api/front/user/live?type=anchorList",
        method: "get",
        params: data,
    });
}

export function getIndexData(data) {
    return request({
        url: "/api/front/user/live?type=index",
        method: "get",
        data,
    });
}

export function getStreamingDetail(data) {
    return request({
        url: "/api/front/user/infos?type=detail",
        method: "get",
        params: data,
    });
}

export function getStreamingList(data) {
    return request({
        url: "/api/front/user/live?type=list",
        method: "get",
        params: data,
    });
}

export function streamingSubscribe(data) {
    return request({
        url: "/api/front/user/live?type=subscribe",
        method: "post",
        data,
    });
}

export function getSubscribeList(data) {
    return request({
        url: "/api/front/user/infos?type=attention",
        method: "get",
        params: data,
    });
}

export function getHistoryList(data) {
    return request({
        url: "/api/front/user/infos?type=log",
        method: "get",
        params: data,
    });
}

export function getStreamingWatcherList(data) {
    return request({
        url: "/api/front/user/infos?type=live_user",
        method: "get",
        params: data,
    });
}

export function watcherBan(data) {
    return request({
        url: "/api/front/user/live?type=banned",
        method: "post",
        data,
    });
}

export function watcherBlackList(data) {
    return request({
        url: "/api/front/user/live?type=blacklist",
        method: "post",
        data,
    });
}

export function streamingApply(data) {
    return request({
        url: "/api/front/user/infos?type=restrict",
        method: "post",
        data,
    });
}

export function allMute(data) {
    return request({
        url: "/api/front/user/live?type=live_banned",
        method: "post",
        data,
    });
}

export function streamingSign(data) {
    return request({
        url: "/api/front/user/infos?type=sign",
        method: "post",
        data,
    });
}

export function streamTime(data) {
    return request({
        url: "/api/front/user/infos?type=getLiveInTime",
        method: "get",
        params: data,
    });
}

// 获取直播 auth token
export function getAuthtoken(device_id) {
    return request({
        url: "/api/front/user/live?type=authtoken",
        method: "get",
        params: {
            device_id
        }
    });
}

// 获取阿里云互动课堂token
export function getAliyunAuthtoken(username,password){
    return request({
        url: AliUrl + '/api/v1/class/login',
        method: "post",
        data: {
            password:password,
            username:username
        }
    })
}
// 获取课堂信息（主要是直播的各种URL）
export function getInfo(id,user_id){
    return request({
        url:AliUrl + '/api/v1/class/get',
        method: "post",
        data: {
            id:id,
            user_id:user_id
        }
    })
}
// 加入课堂
export function joinClass(class_id,user_avatar,user_id,user_name){
    return request({
        url:AliUrl + '/api/v1/class/joinClass',
        method:'post',
        data:{
            class_id: class_id,
            user_avatar: user_avatar,
            user_id: user_id,
            user_name: user_name
        }
    })
}
// 获取连麦信息
export function getMeetingInfo(id){
    return request({
        url:AliUrl + '/api/v1/class/getMeetingInfo',
        method:'post',
        data:{
            id:id
        }
    })
}
// 获取发送IM时的需要的token
export function getIMToken(user_id,device_id,device_type,im_server){
    return request({
        url:AliUrl + '/api/v1/class/token',
        method:'post',
        data:{
            user_id:user_id,
            device_id:device_id,
            device_type:device_type,
            im_server:im_server
        }
    })
}
// 获取直播间成员列表
export function getMembersList(class_id,identity,status,page_num,page_size){
    return request({
        url:AliUrl + '/api/v1/class/listMembers',
        method: 'post',
        data: {
            class_id:class_id,
            identity:identity,// 角色.0: 所有,1：学生,2：老师
            status:status,// 成员状态。0：所有,1：正常,2：离开,3：踢出
            page_num:page_num,
            page_size:page_size
        }
    })
}
// 离开教室
// export function leaveClass(class_id,user_id){
//     return request({
//         url:AliUrl + '/api/v1/class/leaveClass',
//         method: 'post',
//         data:{
//             class_id:class_id,
//             user_id:user_id,
//         }
//     })
// }
// 离开教室
export function leaveClass(class_id,user_id){ // 离开直播间。因为 fetch 开启 keepalive 时即便页面刷新、关闭也可以成功发送数据，所以离开的接口优先使用 fetch
    fetch(process.env.VUE_APP_AUI_LIVE_BASE_HTTP + '/api/v1/class/leaveClass',{
        method:'post',
        body:JSON.stringify({
            user_id: user_id,
            class_id: class_id
        }),
        headers: {
            'Content-Type': 'application/json',
            'Authorization':`Bearer ${sessionStorage.getItem('AliToken')}`
        },
        keepalive: true,
        withCredentials: true,
        credentials: 'omit',
    })
}

// 关注主播
export function follow(id) {
    return request({
        url: `/api/front/user/live?type=live_follow&id=${id}`,
        method: "post"
    });
}

// 取消关注
export function unfollow(id) {
    return request({
        url: `/api/front/user/live?type=live_unfollow&id=${id}`,
        method: "post"
    });
}

// 点赞
export function like(id) {
    return request({
        url: `/api/front/user/live?type=live_like&id=${id}`,
        method: "post"
    });
}

// 取消点赞
export function cancellike(id) {
    return request({
        url: `/api/front/user/live?type=live_cancellike&id=${id}`,
        method: "post"
    });
}

export function update(id) {
    return request({
        url: `/api/front/user/live?type=live_update&id=${id}`,
        method: "post"
    });
}

// 我关注的主播
export function getFollows() {
    return request({
        url: "/api/front/user/infos?type=follows",
        method: "get"
    });
}

// 直播回放
export function getreplyinfo(id) {
    return request({
        url: `/api/front/user/infos?type=getreplyinfo&id=${id}`,
        method: "get"
    });
}

// 直播间被处理的用户列表
export function getbannedorblacklistaudience(id) {
    return request({
        url: `/api/front/user/infos?type=bannedorblacklistaudience&id=${id}`,
        method: "get"
    });
}

// 我的收藏
export function getFavsList(data) {
    return request({
        url: "/api/front/user/infos?type=favs",
        method: "get",
        params: data,
    });
}

// 收藏
export function favs(id) {
    return request({
        url: `/api/front/user/live?type=live_fav&id=${id}`,
        method: "post"
    });
}

// 取消收藏
export function cancelfavs(id) {
    return request({
        url: `/api/front/user/live?type=live_cancelfav&id=${id}`,
        method: "post"
    });
}

export function setTopMessage({id, content}) {
    return request({
        url: `/api/front/user/live?type=setTopMessage&id=${id}`,
        data: {content},
        method: "post"
    });
}

export function cancelTopMessage({id}) {
    return request({
        url: `/api/front/user/live?type=cancelTopMessage&id=${id}`,
        method: "post"
    });
}
// 阿里服务的接口地址改成这个了 AliUrl
